
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18.958c-.525 0-1.017-.2-1.383-.575L7.35 17.117a.95.95 0 00-.5-.209h-1.8a1.956 1.956 0 01-1.958-1.958v-1.8a.95.95 0 00-.209-.5l-1.266-1.267A1.948 1.948 0 011.042 10c0-.525.2-1.017.575-1.383L2.883 7.35a.95.95 0 00.209-.5v-1.8c0-1.083.875-1.958 1.958-1.958h1.8a.95.95 0 00.5-.209l1.267-1.266c.733-.734 2.033-.734 2.766 0l1.267 1.266c.1.1.367.209.5.209h1.8c1.083 0 1.958.875 1.958 1.958v1.8c0 .133.109.4.209.5l1.266 1.267c.367.366.575.858.575 1.383s-.2 1.017-.575 1.383l-1.266 1.267a.95.95 0 00-.209.5v1.8a1.956 1.956 0 01-1.958 1.958h-1.8a.95.95 0 00-.5.209l-1.267 1.266a1.914 1.914 0 01-1.383.575zm-6.233-7.191c.333.333.575.916.575 1.383v1.8c0 .392.316.708.708.708h1.8c.467 0 1.05.242 1.383.575L9.5 17.5a.725.725 0 001 0l1.267-1.267c.333-.333.916-.575 1.383-.575h1.8a.708.708 0 00.708-.708v-1.8c0-.467.242-1.05.575-1.383L17.5 10.5a.7.7 0 00.208-.5.7.7 0 00-.208-.5l-1.267-1.267c-.333-.333-.575-.916-.575-1.383v-1.8a.708.708 0 00-.708-.708h-1.8c-.467 0-1.05-.242-1.383-.575L10.5 2.5a.725.725 0 00-1 0L8.233 3.767c-.333.333-.916.575-1.383.575h-1.8a.708.708 0 00-.708.708v1.8c0 .467-.242 1.05-.575 1.383L2.5 9.5a.7.7 0 00-.208.5.7.7 0 00.208.5l1.267 1.267z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.5 13.333a.838.838 0 01-.841-.833c0-.458.374-.833.833-.833.458 0 .833.375.833.833a.829.829 0 01-.825.833zM7.508 8.333a.838.838 0 01-.841-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.829.829 0 01-.825.833zM7.5 13.125a.618.618 0 01-.442-.183.629.629 0 010-.884l5-5a.629.629 0 01.884 0 .629.629 0 010 .884l-5 5a.618.618 0 01-.442.183z","fill":"#fff"}})])
          )
        }
      }
    